import React from "react";
import { Box } from "@mui/material";
import { TypographyStyled } from "./InsurersContactCard.styles";
const InsurersContactCard = ({ contactPerson }) => {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(TypographyStyled, { variant: "body1" }, contactPerson.name), /* @__PURE__ */ React.createElement(TypographyStyled, { variant: "body1" }, contactPerson.phone), /* @__PURE__ */ React.createElement(TypographyStyled, { variant: "body1" }, contactPerson.email), /* @__PURE__ */ React.createElement(Box, { m: 2 }));
};
export default InsurersContactCard;
